import React from 'react';

interface BreadcrumbNavigationProps {
  isDistrictAdmin: () => boolean;
  isBlockAdmin: () => boolean;
  selectedState: string | number;
  selectedDistrict: string;
  selectedBlock: string;
  selectedVillage: string;
  onResetFilters: () => void;
  onStateChange: (state: string) => void;
  onDistrictChange: (district: string) => void;
  onBlockChange: (block: string) => void;
  selectedStateName: string;
  selectedDistrictName: string;
  selectedBlockName: string;
  selectedVillageName: string;
  isStateAdmin: () => boolean;
}

const BreadcrumbNavigation: React.FC<BreadcrumbNavigationProps> = ({
  isDistrictAdmin,
  isBlockAdmin,
  isStateAdmin,
  selectedState,
  selectedDistrict,
  selectedBlock,
  selectedVillage,
  onResetFilters,
  onStateChange,
  onDistrictChange,
  onBlockChange,
  selectedStateName,
  selectedDistrictName,
  selectedBlockName,
  selectedVillageName
}) => {
  // const shouldShowBreadcrumb = 
  //   (isDistrictAdmin() && selectedBlock) || 
  //   (isBlockAdmin() && selectedVillage) ||
  //   (!isDistrictAdmin() && !isBlockAdmin() && (selectedDistrict || selectedBlock || selectedVillage));

  const shouldShowBreadcrumb = selectedState || selectedDistrict || selectedBlock ||  selectedVillage;

  if (!shouldShowBreadcrumb) return null;

  return (
    <div className="card mb-3">
      <div className="card-body">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0">

            {isStateAdmin() && (
              <li className="breadcrumb-item">
                <button
                  type="button"
                  className="btn btn-link p-0 text-decoration-none"
                  onClick={() => onStateChange('')}
                  title={isDistrictAdmin() ? "Go to Block level" : isBlockAdmin() ? "Go to Village level" : "Go to District level"}
                >
                  <i className="ti ti-home me-1"></i>
                  All states
                </button>
              </li>
            )}

            {selectedState && (
              <li className={`breadcrumb-item ${selectedState ? 'active' : ''}`}>
                <button
                  type="button"
                  className="btn btn-link p-0 text-decoration-none"
                  onClick={() => onStateChange('')}
                  title={isDistrictAdmin() ? "Go to Block level" : isBlockAdmin() ? "Go to Village level" : "Go to District level"}
                >
                  {selectedStateName}
                </button>
              </li>
            )}

            {selectedDistrict && (
              <li className={`breadcrumb-item ${selectedDistrict ? 'active' : ''}`}>
                <button
                  type="button"
                  className="btn btn-link p-0 text-decoration-none"
                  onClick={() => onDistrictChange('')}
                  title={`View blocks in ${selectedDistrict}`}
                >
                  {selectedDistrictName}
                </button>
              </li>
            )}

            {selectedBlock && (
              <li className={`breadcrumb-item ${selectedBlock ? 'active' : ''}`}>
                <button
                  type="button"
                  className="btn btn-link p-0 text-decoration-none"
                  onClick={() => onBlockChange('')}
                  title={`View villages in ${selectedBlock}`}
                >
                  {selectedBlockName}
                </button>
              </li>
            )}

            {selectedVillage && (
              <li className="breadcrumb-item active" aria-current="page">
                {selectedVillageName}
              </li>
            )}

          </ol>
        </nav>
      </div>
    </div>
  );
};

export default BreadcrumbNavigation;
